import { useEffect } from "react";

export const SITE_ORIGIN = "https://ygtabln.cn";

export interface SeoOptions {
  title: string;
  description: string;
  keywords?: string;
  path?: string;
  type?: "website" | "article" | "profile";
  jsonLd?: Record<string, unknown> | Array<Record<string, unknown>>;
}

function upsertMeta(attr: "name" | "property", key: string, content: string) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function useSeo(options: SeoOptions) {
  const { title, description, keywords, path = "/", type = "website", jsonLd } = options;
  const jsonLdKey = jsonLd ? JSON.stringify(jsonLd) : "";

  useEffect(() => {
    document.title = title;
    const url = `${SITE_ORIGIN}${path}`;

    upsertMeta("name", "description", description);
    if (keywords) {
      upsertMeta("name", "keywords", keywords);
    }
    upsertMeta("name", "robots", "index,follow");
    upsertMeta("name", "author", "直曝编辑部");
    upsertMeta("name", "theme-color", "#fbf7f1");

    upsertMeta("property", "og:site_name", "直曝 · 网络爆料投稿平台");
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:type", type);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:locale", "zh_CN");

    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);

    let scriptEl: HTMLScriptElement | null = null;
    if (jsonLdKey) {
      scriptEl = document.createElement("script");
      scriptEl.type = "application/ld+json";
      scriptEl.textContent = jsonLdKey;
      scriptEl.setAttribute("data-page-schema", "true");
      document.head.appendChild(scriptEl);
    }

    return () => {
      if (scriptEl && scriptEl.parentNode) {
        scriptEl.parentNode.removeChild(scriptEl);
      }
    };
  }, [title, description, keywords, path, type, jsonLdKey]);
}